module.exports = __webpack_public_path__ + "static/tm-eraBellThompson-d9072756b5a2c858de802a4938358937.png";